import { useState } from "react";
import { MessageCircle } from "lucide-react";
import { useSettings } from "../context/SettingsContext";

export function formatWhatsAppUrl(rawPhoneOrUrl, message = "") {
  if (!rawPhoneOrUrl) return "https://wa.me/923000000000";
  
  if (rawPhoneOrUrl.startsWith("http://") || rawPhoneOrUrl.startsWith("https://")) {
    try {
      const url = new URL(rawPhoneOrUrl);
      if (message) {
        url.searchParams.set("text", message);
      }
      return url.toString();
    } catch {
      return rawPhoneOrUrl;
    }
  }

  const digits = rawPhoneOrUrl.replace(/\D/g, "");
  const baseUrl = `https://wa.me/${digits}`;
  return message ? `${baseUrl}?text=${encodeURIComponent(message)}` : baseUrl;
}

export default function WhatsAppFloat() {
  const site = useSettings();
  const [hovered, setHovered] = useState(false);

  const rawContact = site?.social_links?.whatsapp || site?.phone || "+923001123344";
  const defaultText = `Hi ${site?.name || "Pickleballgearz"}, I am interested in your pickleball manufacturing & export services.`;
  const whatsappUrl = formatWhatsAppUrl(rawContact, defaultText);

  return (
    <div className="fixed bottom-20 right-4 z-50 md:bottom-8 md:right-8 flex items-center gap-3">
      {hovered && (
        <div className="hidden sm:block animate-fade-in rounded-lg bg-neutral-900 px-3.5 py-2 text-xs font-medium text-white shadow-xl border border-white/10">
          <p className="font-semibold text-emerald-400">Direct B2B WhatsApp</p>
          <p className="text-neutral-300 text-[11px]">Chat with factory export team</p>
        </div>
      )}
      
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        aria-label="Contact us on WhatsApp"
        className="group relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_8px_30px_rgb(37,211,102,0.4)] transition-all duration-300 hover:scale-110 hover:shadow-[0_12px_35px_rgb(37,211,102,0.6)] focus:outline-none focus:ring-4 focus:ring-emerald-400/30"
      >
        <span className="absolute -top-1 -right-1 flex h-4 w-4">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-4 w-4 bg-emerald-500 border-2 border-white"></span>
        </span>
        <MessageCircle size={28} className="transition-transform group-hover:rotate-12" />
      </a>
    </div>
  );
}
